import { connect } from 'react-redux';
import CashInFailure from '../../../components/modals/CashInFailure';
import { close } from '../../../modules/modal/actions';

const mapDispatchToProps = {
  close
};

export default connect(null, mapDispatchToProps)(CashInFailure);
